export enum ChildOnboardingStatus {
  REGISTER = 'REGISTER',
  AWAITING_LG2CONFIRMATION = 'AWAITING_LG2CONFIRMATION',
  CONFIRMED = 'CONFIRMED',
}
